import { render } from "./LoadForm.vue?vue&type=template&id=3550bed6&scoped=true"
import script from "./LoadForm.vue?vue&type=script&lang=js"
export * from "./LoadForm.vue?vue&type=script&lang=js"

import "./LoadForm.vue?vue&type=style&index=0&id=3550bed6&lang=css"
import "./LoadForm.vue?vue&type=style&index=1&id=3550bed6&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3550bed6"]])

export default __exports__